import "animate.css";
import "aos/dist/aos.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "../src/index.css";
import "./App.css";
import { adminroutes } from "./Adminpages/AdminRoutes";
import LogIn from "./Adminpages/Authentication/Login";
import AdminLayout from "./Adminpages/Layout";
import ForgotPassword from "./authentication/Forgotpassword";
import Login from "./authentication/login";
import Registration from "./authentication/Registration";
import BuyBot from "./dashboard/BuyBot";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import { routes } from "./routes/Routes";
import Home from "./Welcome";
// import IFCTrade from "./IFCtrade";
import Website from "./Website";
import RegistrationTopup from "./dashboard/pages/Topup/RegistrationTopup";
import FataFatScanner from "./scanner/FataFatScanner";

const App = () => {
  const user = localStorage.getItem("logindataen");

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {/* <Route path="/" element={<BuyBot />} /> */}
        {/* <Route path="/" element={<IFCTrade />} /> */}
        <Route path="/" element={<FataFatScanner />} />
        <Route path="/buy-bot" element={<BuyBot />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/topup_without" element={<RegistrationTopup />} />

        {/* //admin */}
        <Route path="/adminlogin" element={<LogIn />} />

        {user ? (
          adminroutes.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              element={
                <AdminLayout
                  id={route.id}
                  navLink={route.path}
                  navItem={route.navItem}
                  component={route.component}
                />
              }
            />
          ))
        ) : (
          <Route path="*" element={<Website />} />
        )}
        {/* Protected Routes */}
        {user ? (
          routes.map((route, i) => (
            <Route key={i} path={route.path} element={route.element} />
          ))
        ) : (
          <Route path="*" element={<Website />} />
        )}
      </Routes>
    </Router>
  );
};

export default App;
